import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'
import SponsoredLabel from './SponsoredLabel'

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
`

const TitleHeading = styled(Heading)`
  min-width: 0;
  flex: 1 1 auto;
`

const SponsoredLabelWrapper = styled.span`
  flex: 0 0 auto;
`

interface Props extends PropsWithChildren {
  sponsored?: boolean
}

function SearchTileRowTitle({ children, sponsored = false }: Props) {
  const title = <TitleHeading variant="heading5" lineClamp={3}>
    {children}
  </TitleHeading>

  if (!sponsored) {
    return title
  }

  return <TitleRow>
    {title}
    <SponsoredLabelWrapper>
      <SponsoredLabel />
    </SponsoredLabelWrapper>
  </TitleRow>
}

export default SearchTileRowTitle
